import { useEffect, useState } from "react";
import {
  validateRequired,
  validateNumeric,
  validatePercentage,
  ErrorMessage,
} from "../../utlis/function.js";
import CommonLoader from "../common/CommonLoader.jsx";
import { useGlobalStates } from "../../utlis/ClubsContext.js";
import { UserRole } from "../../utlis/constant.js";

const EditableInfoCard = ({
  title,
  value,
  onSave,
  validationType = "text",
  fieldName = title,
  customErrorMessage,
  className = "",
  isLoading,
  showEditButton = true,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(value);
    const { userRole } = useGlobalStates();
  
  const [errors, setErrors] = useState({});

 
  useEffect(() => {
  setEditValue(value === "-" ? "" : value ?? "");
}, [value]);
  
  // Enhanced validation function using common validation utilities
  const validateField = (fieldValue) => {
    const trimmedValue =
      fieldValue === null || fieldValue === undefined
        ? ""
        : String(fieldValue).trim(); // ✅ SAFE
        // if(Number(trimmedValue) === 0) return `${fieldName} cannot be zero`;

    // Required validation
    if (!validateRequired(trimmedValue)) {
      return `${fieldName} is required`;
    }

    switch (validationType) {
      case "numeric":
        if (!validateNumeric(trimmedValue)) {
          return `${fieldName} must be a valid non-negative number`;
        }
        break;

      case "percentage": {
        const cleanedPercentage = trimmedValue.replace(/[^0-9.]/g, "");
        if (!validatePercentage(cleanedPercentage)) {
          return `${fieldName} must be between 0 and 100`;
        }
        break;
      }

      case "currency-non-zero": {
      const cleanCurrency = trimmedValue.replace(/[$,]/g, "");
      const numericValue = Number(cleanCurrency);

      if (!validateNumeric(cleanCurrency)) {
        return `${fieldName} must be a valid amount`;
      }
      if (numericValue <= 0) {
        return `${fieldName} must be greater than 0`;
      }
      break;
    }
      default:
        break;
    }

    return "";
  };

  const handleSave = async () => {
    const error = validateField(editValue);

    if (error) {
      setErrors({ field: customErrorMessage || error });
      return;
    }

    // Clear errors and save
    setErrors({});
    await onSave(editValue);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditValue(value);
    setErrors({});
    setIsEditing(false);
  };

  // Clear error when user starts typing
  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setEditValue(newValue);

    if (errors.field && newValue.trim() !== "") {
      setErrors({});
    }
  };

  // Handle Enter key press to save
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSave();
    }
  };
  return (
    <div className={`bg-white rounded-xl p-6 main-shadow ${className}`}>
      {/* {isLoading && <CommonLoader fullScreen />} */}
      <div className="flex items-start justify-between mb-4">
        <p className="text-base font-normal text-textcolor tracking-[0] leading-[normal]">
          {title}
        </p>
        {!isEditing && showEditButton && (
          <button
            onClick={() => setIsEditing(true)}
             disabled={userRole === UserRole.Viewer}
            className={`flex items-center  ${userRole === UserRole.Viewer ? "cursor-not-allowed opacity-50" : "cursor-pointer"} gap-1 text-base font-medium text-black hover:text-primary transition-colors`}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Edit
          </button>
        )}
      </div>

      {isEditing ? (
        <div className="space-y-3">
          <input
            type="text"
            value={editValue}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            className={`w-full px-3 py-2 text-2xl font-semibold text-black border rounded-lg focus:outline-none focus:border-primary transition-colors ${
              errors.field ? "border-red-500" : "border-gray-300"
            }`}
            autoFocus
          />
          {errors.field && <ErrorMessage message={errors.field} />}
          <div className="flex items-center gap-2">
            <button
              onClick={handleSave}
              disabled={isLoading}
              className="flex-1 px-4 py-2 bg-primary hover:bg-hover text-white font-medium text-sm rounded-lg transition-colors"
            >
              {isLoading ? (
                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin" />
                  Saving...
                </div>
              ) : (
                "Save"
              )}
            </button>
            <button
              onClick={handleCancel}
              className="flex-1 px-4 py-2 bg-white border border-gray-200 text-textcolor font-medium text-sm rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <h2 className="text-[40px] font-semibold text-black tracking-[0] leading-[48px]">
          {value || "0"}
        </h2>
      )}
    </div>
  );
};

export default EditableInfoCard;
